<div id="newsList" class="ya-typography">
  <ya-subheader [hasContent]="false"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop">
    <ng-container *ngIf="hasData; then pageTemplate else emptyTemplate"></ng-container>
    <ng-template #pageTemplate>
      <div class="news-detail-image-wrapper">
        <div class="aspect-ratio-box">
          <div class="aspect-ratio-box-inside">
            <div class="aspect-ration-img-box">
              <img class="ya_image" [src]="newsViewModel.image_photo" alt="" />
            </div>
          </div>
        </div>
      </div>
          <div class="news-detail-wrapper">
            <section class="news-detail-content">
              <div class="news-detail-page-content-header ya-detail-page-header">
                <div class="news-detail-title">
                <div id="headerTitleContainer" class="news-detail-date-wrapper ya-caption">
                <span>{{newsViewModel.day}}{{newsViewModel.month}}</span>
                <span>{{newsViewModel.year}}</span>
                </div>
                <h2 id="headerTitle">{{newsViewModel.label}}</h2>
              </div>
                <div class="news-detail-like">
                  <ya-favoritebutton [contentType]="contentType.News" [likeStatus]="newsViewModel.like"
                    [modelId]="newsViewModel.id">
                  </ya-favoritebutton>
                </div>
              </div>
              <p  [innerHTML]="newsViewModel.text"> </p>
              <div class="actions">
                <div class="news-detail-ranking-bar">
                  <bar-rating [(rate)]="newsViewModel.rate" [max]="5" [readOnly]="true" [theme]="'fontawesome-o'"></bar-rating>
                  <div class="rate-click-div" (click)="openRateModel(newsViewModel)"></div>
                </div>
              </div>
            </section>
          </div>
    </ng-template>
    <ng-template #emptyTemplate>
      <ya-emptypage></ya-emptypage>
    </ng-template>
  </div>
</div>